import { __rest, __assign, __makeTemplateObject } from 'tslib';
import React, { forwardRef } from 'react';
import classnames from 'classnames';
import { styled } from 'styled-components';
import '../../../reset/HtmlA/HtmlA.js';
import '../../../reset/HtmlButton/HtmlButton.js';
import '../../../reset/HtmlDiv/HtmlDiv.js';
import '../../../reset/HtmlFieldSet/HtmlFieldSet.js';
import '../../../reset/HtmlH/HtmlH.js';
import '../../../reset/HtmlInput/HtmlInput.js';
import '../../../reset/HtmlLabel/HtmlLabel.js';
import '../../../reset/HtmlLegend/HtmlLegend.js';
import '../../../reset/HtmlLi/HtmlLi.js';
import '../../../reset/HtmlNav/HtmlNav.js';
import '../../../reset/HtmlOl/HtmlOl.js';
import { HtmlSpan } from '../../../reset/HtmlSpan/HtmlSpan.js';
import '../../../reset/HtmlTextarea/HtmlTextarea.js';
import '../../../reset/HtmlUl/HtmlUl.js';
import '../../../reset/HtmlTable/HtmlTable.js';
import '../../../reset/HtmlTable/HtmlTableCaption.js';
import '../../../reset/HtmlTable/HtmlTableHeader.js';
import '../../../reset/HtmlTable/HtmlTableRow.js';
import '../../../reset/HtmlTable/HtmlTableBody.js';
import '../../../reset/HtmlTable/HtmlTableHeaderCell.js';
import '../../../reset/HtmlTable/HtmlTableCell.js';
import { SuomifiThemeConsumer } from '../../theme/SuomifiThemeProvider/SuomifiThemeProvider.js';
import '../../theme/SuomifiTheme/SuomifiTheme.js';
import { SpacingConsumer } from '../../theme/SpacingProvider/SpacingProvider.js';
import { separateMarginProps } from '../../theme/utils/spacing.js';
import { baseStyles } from './HintText.baseStyles.js';
import { filterDuplicateKeys } from '../../../utils/common/common.js';

var baseClassName = 'fi-hint-text';
var StyledHintText = styled(function (_a) {
  var className = _a.className;
    _a.globalMargins;
    _a.theme;
    var children = _a.children,
    rest = __rest(_a, ["className", "globalMargins", "theme", "children"]);
  var _b = separateMarginProps(rest),
    passProps = _b[1];
  return /*#__PURE__*/React.createElement(HtmlSpan, __assign({}, passProps, {
    className: classnames(className, baseClassName, {}),
    style: __assign({}, passProps === null || passProps === void 0 ? void 0 : passProps.style)
  }), children);
}).withConfig({
  componentId: "sc-ketar6-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var theme = _a.theme,
    globalMargins = _a.globalMargins,
    rest = __rest(_a, ["theme", "globalMargins"]);
  var _b = separateMarginProps(rest),
    marginProps = _b[0];
  var cleanedGlobalMargins = filterDuplicateKeys(globalMargins.hintText, marginProps);
  return baseStyles(theme, cleanedGlobalMargins, marginProps);
});
var HintText = /*#__PURE__*/forwardRef(function (props, ref) {
  var children = props.children,
    passProps = __rest(props, ["children"]);
  if (!children) {
    return null;
  }
  return /*#__PURE__*/React.createElement(SpacingConsumer, null, function (_a) {
    var margins = _a.margins;
    return /*#__PURE__*/React.createElement(SuomifiThemeConsumer, null, function (_a) {
      var suomifiTheme = _a.suomifiTheme;
      return /*#__PURE__*/React.createElement(StyledHintText, __assign({
        forwardedRef: ref,
        theme: suomifiTheme,
        globalMargins: margins
      }, passProps), children);
    });
  });
});
HintText.displayName = 'HintText';
var templateObject_1;

export { HintText };
//# sourceMappingURL=HintText.js.map
